import { Component, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Network, NetworkStatus } from '@capacitor/network'; // Import Network from Capacitor

@Component({
  selector: 'app-offline-message-bar',
  template: ``,
  styles: [``]
  // template: `
  //   <div *ngIf="showOfflineMessage" class="offline-message-bar">
  //     {{ offlineMessageText }}
  //   </div>
  // `,
  // styles: [`
  //   .offline-message-bar {
  //     background-color: red;
  //     color: white;
  //     text-align: center;
  //     padding: 10px;
  //     position: fixed;
  //     bottom: 0;
  //     left: 0;
  //     width: 100%;
  //     z-index: 9999;
  //   }
  // `]
})
export class OfflineMessageBarComponent implements OnInit {

  showOfflineMessage: boolean = false;
  offlineMessageText: string = 'Offline: Connect to the Internet to enable fixdd.';

  constructor(private toastController: ToastController) {}

  ngOnInit() {
    this.initializeNetworkEvents();
    this.checkNetworkStatus();
    console.log('OfflineMessageBarComponent initialized');
  }

  async initializeNetworkEvents() {
    // Listen for network status change events
    Network.addListener('networkStatusChange', (status: NetworkStatus) => {
      console.log('Network status changed', status);
      this.showOfflineMessage = !status.connected;
      if (this.showOfflineMessage) {
        this.displayOfflineToast();
      } else {
        this.dismissOfflineToast();
      }
    });
  }

  async checkNetworkStatus() {
    // Check the current network status
    const status = await Network.getStatus();
    this.showOfflineMessage = !status.connected;
    if (this.showOfflineMessage) {
      this.displayOfflineToast();
    } else {
      this.dismissOfflineToast();
    }
  }

  async displayOfflineToast() {
    const toast = await this.toastController.create({
      message: this.offlineMessageText,
      duration: 5000, // Set duration to 0 for a permanent toast
      position: 'top', // Adjust the position as needed
      color: 'danger', // Customize the color
    });
  
    await toast.present();
  }
  
  async dismissOfflineToast() {
    const toast = await this.toastController.getTop();
    if (toast) {
      await toast.dismiss();
    }
  }
}
